import { makeApiCallWithAny } from "./tokenService";
import { IWorkHoursItem } from "../models/workHours/workHoursItem";

export const getUpToDateWorkHours = (
    salaryPeriodId: string,
    calculateFillingHours = false,
    signal?: AbortSignal
): Promise<IWorkHoursItem[]> => {
    return makeApiCallWithAny(
        `api/workhours/up-to-date?salaryPeriodId=${encodeURIComponent(
            salaryPeriodId
        )}&calculateFillingHours=${calculateFillingHours}`,
        signal
    );
};

export const getUpToDateNormalWorkHours = (
    startDate: string,
    endDate: string,
    signal?: AbortSignal
): Promise<IWorkHoursItem[]> => {
    return makeApiCallWithAny(
        `api/workhours/normal/up-to-date?startDate=${encodeURIComponent(
            startDate
        )}&endDate=${encodeURIComponent(endDate)}`,
        signal
    );
};
